import { useMutation } from "@apollo/client"
import { DeleteIntegrationSourceDocument } from "@hydrologiq/gql-experience/graphql"
import { usePrimaryClientIfAvailable } from "../../providers/DualGraphQLProvider"

export const useDeleteIntegrationSource = () => {
  const client = usePrimaryClientIfAvailable()
  const [deleteSource, { loading, error }] = useMutation(DeleteIntegrationSourceDocument, { client })

  return {
    deleteSource,
    loading,
    error,
  }
}
